import { useStytchMemberSession } from '@stytch/react/b2b';
import React, { ReactNode, useEffect } from 'react';
import { useFirebaseCustomAuth } from '../firebase';

export function FirebaseAuthWrapper({ children }: { children: ReactNode }) {
    const { session, fromCache } = useStytchMemberSession();

    const { login, logout } = useFirebaseCustomAuth();

    useEffect(() => {
        if (session && !fromCache) {
            login();
        } else if (!session) {
            logout();
        }
    }, [fromCache, login, logout, session])

    return (
        <>
            { children }
        </>
    )
}